import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';

const importJobsOpenSauce = () => import(/* webpackChunkName: "jobs-opensauce" */ './containers/JobsOpenSauceContainer');

const JobsOpenSauceRoutes = ({ match }) => (
  <Switch>
    <BundleRoute
      load={importJobsOpenSauce}
      path={`${match.url}/user/:username/:tabName?`}
    />
    <Redirect
      from={`${match.url}/u/:username/:tabName?`}
      to={`${match.url}/user/:username/:tabName?`}
    />
  </Switch>
);

JobsOpenSauceRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};


export default JobsOpenSauceRoutes;
export { JobsOpenSauceRoutes };
